import React, { createElement, useEffect, useState } from 'react';
import { Input, Form, Col } from 'antd';
import { getInfo } from '../../../api/common';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const edit = urlParams.get('edit');
const FormCreator = (props, ref) => {
    const { __id, title, span, column, form } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    useEffect(() => {
        setError(false);
        try {
            if (Boolean(__id)) {
                getInfo().then((res) => {
                    form.setFieldValue(__id, res.user.nickName);
                });
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('创建人回显失败,请更新组件');
        }
    });
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '创建人', name: __id },
                createElement(Input, { disabled: true })))))));
};
export default React.forwardRef(FormCreator);
